$(function () {
  const copyClipboard = {
    init() {
      copyClipboard.create();
    },
    create() {
      $('[data-copy-clipboard]').on('click', function(e) {
        e.preventDefault();
        const self = $(this);
        const valueToCopy = self.data('value');
        navigator.clipboard.writeText(valueToCopy);

        self.find('[data-copied]').stop().fadeIn();
        setTimeout(function() {
          self.find('[data-copied]').stop().fadeOut();
        }, 1500);
      });
    },
  };

  copyClipboard.init();
});
